import "./condition.css"
import pdf_icon from "../../../assets/pdf_icon.png"
import conditions from "../../../assets/financial.webp";
import React, {useEffect, useState} from "react";
import Accordion from 'react-bootstrap/Accordion';
import {Link, useNavigate} from "react-router-dom";
import {setConditionInfo, setFinder, setLimit} from "../../../redux/conditions_store";
import {setPersonalData} from "../../../redux/personal_store";
import {connect} from "react-redux";
import {useTranslation} from "react-i18next";
import Logout from "../../logout/Logout";
import ProgressBar from "react-bootstrap/ProgressBar";
import apiClient from "../../../utils/axios";

function Conditions({conditionInfo, setConditionInfo, appData, personalData, account}) {

    let backTo = '/experience'
    if (appData.account_type === 'custodial') backTo = '/experience'
    if (appData.account_type === 'joint') backTo = '/owner-info'
    if (appData.account_type === 'speciality') backTo = '/authorized-signers'
    if (appData.account_type === 'IRA') backTo = '/ira-account'

    const [activeTab, setActiveTab] = useState("0");
    const [foreignFinderData, setForeignFinderData] = useState(null);
    const [limitTrade, setLimitTrade] = useState(null);

    const {t} = useTranslation()
    const navigate = useNavigate()
    const campaignSlug = window.campaign_slug || ''

    let now;

    if (appData.account_type === "joint" || appData.account_type === "IRA") {
        now = 80
    } else {
        now = 70
    }

    const [conditionErrors, setConditionErrors] = useState({
        customer: '',
        margin: '',
        option: '',
        taxPlayer: '',
        clear: '',
        trading: '',
        agreew8: '',
        disclosure: '',
        privacy: '',
        finder: '',
        limit: ''
    });

    useEffect(() => {
        setConditionInfo((prevConditionInfo) => ({
            ...prevConditionInfo,
            ExemptW9: appData.citizenship_status === "UsCitizen" && prevConditionInfo.taxPlayer,
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appData.citizenship_status]);

    useEffect(() => {
        setConditionInfo({
            ...conditionInfo,
            clear: true,
            trading: true,
            agreeConfirm: true,
            agreeEstatement: true,
            agreeProxy: true,
            agreePros: true,
            agreeEtax: true,
            privacy: true
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        setConditionErrors({
            customer: '',
            margin: '',
            option: '',
            clear: '',
            trading: '',
            agreew8: '',
            privacy: '',
            agreeConfirm: '',
            agreeEstatement: '',
            agreeProxy: '',
            agreePros: '',
            agreeEtax: '',
            finder: '',
            limit: ''
        });

        let isValid = true;
        let firstErrorTab = null;

        const tabOrder = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

        for (const tab of tabOrder) {
            if (tab === "0" && !conditionInfo.customer) {
                setConditionErrors((prevErrors) => ({
                    ...prevErrors,
                    customer: t('errors.required_field'),
                }));
                isValid = false;
                firstErrorTab = "0";
                break;
            }

            if (tab === "1" && !conditionInfo.margin && account.accountType !== 'cashAcc') {
                setConditionErrors((prevErrors) => ({
                    ...prevErrors,
                    margin: t('errors.required_field'),
                }));
                isValid = false;
                firstErrorTab = "1";
                break;
            }

            if (tab === "2" && !conditionInfo.option && account.selectedOption !== 'level0') {
                setConditionErrors((prevErrors) => ({
                    ...prevErrors,
                    option: t('errors.required_field'),
                }));
                isValid = false;
                firstErrorTab = "2";
                break;
            }

            if (tab === "3" && !conditionInfo.agreew8 && appData.citizenship_status === "non_resident") {
                setConditionErrors((prevErrors) => ({
                    ...prevErrors,
                    agreew8: t('errors.required_field'),
                }));
                isValid = false;
                firstErrorTab = "3";
                break;
            }

            if (tab === "4" && !conditionInfo.clear) {
                setConditionErrors((prevErrors) => ({
                    ...prevErrors,
                    clear: t('errors.required_field'),
                }));
                isValid = false;
                firstErrorTab = "4";
                break;
            }

            if (tab === "8" && !conditionInfo.trading) {
                setConditionErrors((prevErrors) => ({
                    ...prevErrors,
                    trading: t('errors.required_field'),
                }));
                isValid = false;
                firstErrorTab = "8";
                break;
            }

            if (tab === "5") {
                const uncheckedCheckboxes = ["agreeConfirm", "agreeEstatement", "agreeProxy", "agreePros", "agreeEtax"]
                    .filter(checkbox => !conditionInfo[checkbox]);

                if (uncheckedCheckboxes.length > 0) {
                    uncheckedCheckboxes.forEach(checkbox => {
                        setConditionErrors(prevErrors => ({
                            ...prevErrors,
                            [checkbox]: t('errors.required_field'),
                        }));
                    });

                    isValid = false;
                    firstErrorTab = "5";
                    break;
                }
            }

            if (tab === "6" && !conditionInfo.privacy) {
                setConditionErrors((prevErrors) => ({
                    ...prevErrors,
                    privacy: t('errors.required_field'),
                }));
                isValid = false;
                firstErrorTab = "6";
                break;
            }

            if (tab === "7" && !conditionInfo.finder && foreignFinderData) {
                setConditionErrors((prevErrors) => ({
                    ...prevErrors,
                    finder: t('errors.required_field'),
                }));
                isValid = false;
                firstErrorTab = "7";
                break;
            }

            if (tab === "9" && !conditionInfo.limit && limitTrade) {
                setConditionErrors((prevErrors) => ({
                    ...prevErrors,
                    limit: t('errors.required_field'),
                }));
                isValid = false;
                firstErrorTab = "9";
                break;
            }
        }

        if (isValid) {
            setConditionInfo(conditions);

            if (!appData.app_id) {
                alert('Missing app id');
            }

            try {
                await updateConditionsValues();

                if (appData.sub_account_type === "omnibus") {
                    navigate('/signature');
                } else {
                    navigate('/review');
                }
            } catch (error) {
                setConditionErrors((prevErrors) => ({
                    ...prevErrors,
                    submitError: error.message,
                }));
            }
        } else {
            setActiveTab(firstErrorTab);
        }
    };

    useEffect(() => {
        fetchReferralsList();

        if (appData.AgreeForeignFinder) {
            setConditionInfo((prevConditionInfo) => ({
                ...prevConditionInfo,
                finder: true,
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleInputChange = (e) => {
        const {name, checked} = e.target;

        setConditionInfo({...conditionInfo, [name]: !conditionInfo[name]});
        setConditionInfo((prevConditionInfo) => ({
            ...prevConditionInfo,
            [name]: checked,
            AgreeForeignFinder: checked ? "" : new Date().toISOString(),
        }));

        if (name === "customer") {
            setActiveTab(activeTab === "1" ? "" : account.accountType === 'cashAcc' && account.selectedOption === 'level0' ? '3' : account.accountType === 'cashAcc' ? '2' : '1');
        } else if (name === "margin") {
            setActiveTab(activeTab === "2" ? "" : account.selectedOption === 'level0' ? "3" : '2');
        } else if (name === "option") {
            setActiveTab(activeTab === "3" ? "" : "3");
        } else if (name === "taxPlayer" || name === "agreew8") {
            setActiveTab(activeTab === "4" ? "" : "4");
        } else if (name === "clear") {
            setActiveTab(activeTab === "5" ? "" : "5");
        } else if (name === "trading") {
            setActiveTab(activeTab === "8" ? "" : "8")
        } else if (name === "limit") {
            setActiveTab(activeTab === "9" ? "" : "9")
        } else if (name === "agreeConfirm") {
            setActiveTab(activeTab === "6" ? "" : "6")
        } else {
            setActiveTab(activeTab === "7" ? "" : "7");
        }
    };

    const getConditionsValues = () => {
        return {
            AgreeCust: conditionInfo.customer ? 'Y' : 'N',
            AgreeMargin: conditionInfo.margin ? 'Y' : 'N',
            AgreeOption: conditionInfo.option ? 'Y' : 'N',
            AddressVerified: conditionInfo.clear ? 'Y' : 'N',
            ExemptW9: conditionInfo.taxPlayer ? 'Y' : 'N',
            AgreeW8BEN: conditionInfo.agreew8 ? 'Y' : 'N',
            AgreeEConfirm: conditionInfo.agreeConfirm ? 'Y' : 'N',
            AgreeEstatement: conditionInfo.agreeEstatement ? 'Y' : 'N',
            AgreeEProxy: conditionInfo.agreeProxy ? 'Y' : 'N',
            AgreeEProspectus: conditionInfo.agreePros ? 'Y' : 'N',
            AgreeETax: conditionInfo.agreeEtax ? 'Y' : 'N',
            OwnerDisclosure: conditionInfo.disclosure ? 'Y' : 'N',
            AgreePrivacy: conditionInfo.privacy ? 'Y' : 'N',
            AgreeForeignFinder: conditionInfo.finder ? 'Y' : 'N',
            ClearingFirm: conditionInfo.clearingFirm ? 'Y' : 'N'
        }
    };

    const fetchReferralsList = async () => {
        try {
            const URL = `${process.env.REACT_APP_API_URL}/api/getReferralsList`;
            const response = await apiClient.get(URL, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    Accept: "application/json, text/plain, */*",
                    "Content-Type": "application/json",
                },
            });

            const matchingFinder = response.data.find((finder) => finder.value.toLowerCase() === appData.hear_about_us.toLowerCase());
            const matchingTrade = response.data.find((limit) => limit.value.toLowerCase() === appData.hear_about_us.toLowerCase())

            if (matchingFinder && matchingFinder.foreignfinder) {
                const parsedData = parseHTML(matchingFinder.foreignfinder);
                setForeignFinderData({...matchingFinder, foreignfinder: parsedData});
            }

            if (matchingTrade && matchingTrade.isLTA) {
                setLimit(matchingTrade.value);
                setLimitTrade(matchingTrade);
            }
        } catch (error) {
            console.error("Error fetching referrals list:", error);
        }
    };

    const parseHTML = (htmlString) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        const elements = Array.from(doc.body.childNodes);

        let parsedContent = [];

        elements.forEach((node) => {
            if (node.nodeType === Node.TEXT_NODE) {
                parsedContent.push({type: 'text', content: node.textContent.trim()});
            } else if (node.nodeName === 'A') {
                parsedContent.push({
                    type: 'link',
                    content: node.textContent.trim(),
                    href: node.getAttribute('href'),
                });
            }
        });

        return parsedContent;
    };

    const updateConditionsValues = async () => {
        const URL = `${process.env.REACT_APP_API_URL}/api/accounts/step6/` + appData.app_id;
        const params = getConditionsValues();

        try {
            const response = await apiClient.put(URL, params, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                }
            });

            if (response.data && response.data.status &&
                ['400', '401', '403', '404', '405', '408', '429', '500', '501', '502', '503', '504', '505'].includes(response.data.status)) {
                throw new Error(response.data.message || 'Unknown error occurred');
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (!appData?.app_id) return;

        const fetchClearingFirm = async () => {
            try {
                const {data} = await apiClient.get(`/accounts/${appData.app_id}`);

                setConditionInfo({
                    ...conditionInfo,
                    clearingFirm: data.ClearingFirm || '',
                });
            } catch (error) {
                console.error("Failed to fetch clearing firm:", error);
            }
        };

        fetchClearingFirm();
    }, [appData?.app_id]);

    return (
        <div className="flex">
            <div className="left_side">
                <img className="w-full" src={conditions} alt=""/>
            </div>
            <div className="right_side">
                <div className="flex justify-content-between align-items-baseline">
                    <div role="progressbar" id="combo" aria-label="progress" className="w-100">
                        <ProgressBar now={now} label={`${now}%`} visuallyHidden/>
                    </div>
                    <Logout/>
                </div>
                <p className="conditions_heading text-center font-normal text-xl">
                    {t('conditions.thanks')} {personalData.firstName} {personalData.lastName}. {t('conditions.terms_condition')}
                </p>
                <p className="conditions_heading_info font-bold text-center text-2xl">
                    {t('conditions.financial_information')}
                </p>
                <form onSubmit={handleSubmit}>
                    <Accordion activeKey={activeTab} onSelect={(key) => setActiveTab(key)}>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>
                                <Link to="/conditions" style={{color: "unset"}}>
                                    {t('conditions.customer_agreement')}
                                </Link>
                            </Accordion.Header>
                            <Accordion.Body>
                                <div className="flex gap-3">
                                    <input type="checkbox" className="agreement_check"
                                           name="customer"
                                           checked={conditionInfo.customer}
                                           onChange={handleInputChange}
                                    />

                                    <p className="agreement_check_text text-base uppercase font-bold text-base uppercase font-bold">
                                        {t('conditions.conditions_governing')} <a
                                        style={{color: "#262424"}}
                                        href="http://www.choicetrade.com/legal.php?page=custagree"
                                        target="_blank"
                                        rel="noreferrer">{t('conditions.customer_agreement')}.</a> {t('conditions.conditions_governing2')}
                                    </p>
                                </div>
                                {conditionErrors.customer &&
                                    <p className="conditions_info_error text-red-500 text-sm">{conditionErrors.customer}</p>
                                }
                                <p className="customer_info text-center font-bold">
                                    {t('conditions.arbitration_agreement')}
                                </p>
                                <p className="fee_acknowledgement">{t('conditions.fee_acknowledgement')}</p>
                                <p className="fee_acknowledgement_text">{t('conditions.service_fee')}</p>
                            </Accordion.Body>
                        </Accordion.Item>

                        {account.accountType !== 'cashAcc' && (
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    <Link to="/conditions" style={{color: "unset"}}>
                                        {t('conditions.margin_agreement')}
                                    </Link>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <div className="flex gap-3 pb-5">
                                        <input type="checkbox" className="agreement_check" name="margin"
                                               checked={conditionInfo.margin}
                                               onChange={handleInputChange}/>
                                        <p className="agreement_check_text text-base uppercase font-bold">{t('conditions.margin_terms')}</p>
                                    </div>
                                    {conditionErrors.margin &&
                                        <p className="conditions_info_error text-red-500 text-sm">{conditionErrors.margin}</p>}
                                    <a href="http://www.choicetrade.com/legal.php?page=disclosures" target="_blank"
                                       className="agreement_text text-lg font-bold"
                                       rel="noreferrer">{t('conditions.margin_risk')}</a>
                                    <div>
                                        <a href="https://choicetrade-media.s3.amazonaws.com/forms/VLOX/MarginAgreement-VLOX.pdf"
                                           target="_blank" className="agreement_text text-lg font-bold"
                                           rel="noreferrer">{t('conditions.margin_agreement1')}</a>
                                    </div>
                                    <div>
                                        <a href="https://choicetrade-media.s3.amazonaws.com/forms/CURV/MarginAgreementCURV.pdf"
                                           className="agreement_text text-lg font-bold" target="_blank"
                                           rel="noreferrer">
                                            {t('conditions.margin_agreement2')}
                                        </a>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        )}

                        {account.selectedOption !== 'level0' && (
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>
                                    <Link to="/conditions"
                                          style={{color: "unset"}}>{t('conditions.options_agreement')}</Link>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <div className="flex gap-3 pb-5">
                                        <input type="checkbox"
                                               className="agreement_check"
                                               name="option"
                                               checked={conditionInfo.option}
                                               onChange={(event) => handleInputChange(event)}/>
                                        <p className="agreement_check_text text-base uppercase font-bold">{t('conditions.any_material_change')}</p>
                                    </div>
                                    {conditionErrors.option &&
                                        <p className="conditions_info_error text-red-500 text-sm">{conditionErrors.option}</p>}
                                    <a href="https://www.choicetrade.com/legal.php?page=disclosures" target="_blank"
                                       className="agreement_text text-lg font-bold"
                                       rel="noreferrer">{t('conditions.option_disclosures')}</a>
                                    <div>
                                        <a href="https://choicetrade-media.s3.amazonaws.com/forms/ETC/optionct.pdf"
                                           target="_blank" className="agreement_text text-lg font-bold"
                                           rel="noreferrer">{t('conditions.options_supplement')}</a>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        )}

                        {appData.citizenship_status !== "non_resident" &&
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>
                                    <Link to="/conditions"
                                          style={{color: "unset"}}>{t('conditions.taxpayer_id_number')}</Link>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <div className="flex gap-3 pb-5">
                                        <input
                                            type="checkbox"
                                            className="agreement_check"
                                            name="taxPlayer"
                                            checked={conditionInfo.taxPlayer}
                                            onChange={(event) => handleInputChange(event)}
                                        />
                                        <p className="agreement_check_text text-base uppercase font-bold">{t('conditions.notified_irs')}</p>
                                    </div>
                                    <div className="certify_text text-center font-bold text-base">
                                        <p>{t('conditions.penalty_of_perjury')}</p>
                                        <p>{t('conditions.number_1')}</p>
                                        <p>{t('conditions.number_2')}</p>
                                        <p>{t('conditions.number_3')}</p>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        }

                        {appData.citizenship_status === "non_resident" &&
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>
                                    <Link to="/conditions"
                                          style={{color: "unset"}}>{t('conditions.agreew8_heading')}</Link>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <div className="flex gap-2 flex-column">
                                        <div className="flex gap-3">
                                            <input
                                                type="checkbox"
                                                className="agreement_check"
                                                name="agreew8"
                                                checked={conditionInfo.agreew8}
                                                onChange={(event) => handleInputChange(event)}
                                            />
                                            <div>
                                                <p className="agreement_check_text text-base uppercase font-bold">{t('conditions.agreew8_text')}</p>
                                                <p className="agreement_check_text text-base uppercase font-bold">{t('conditions.agreew8_text2')}</p>
                                            </div>
                                        </div>
                                        <p>
                                            <img src={pdf_icon} alt="" className="w-2rem"/>
                                            <a href="https://choicetrade-media.s3.amazonaws.com/forms/fw8ben.pdf"
                                               target="_blank" rel="noreferrer" className="text-red-500">
                                                {t('conditions.w8_form')}
                                            </a>
                                        </p>
                                    </div>
                                    {conditionErrors.agreew8 &&
                                        <p className="conditions_info_error text-red-500 text-sm">{conditionErrors.agreew8}</p>}
                                </Accordion.Body>
                            </Accordion.Item>
                        }

                        <Accordion.Item eventKey="4">
                            <Accordion.Header>
                                <Link to="/conditions"
                                      style={{color: "unset"}}>{t('conditions.clearing_authorization')}</Link>
                            </Accordion.Header>
                            <Accordion.Body>
                                <div className="flex gap-3">
                                    <input type="checkbox" className="agreement_check"
                                           name="clear"
                                           checked={conditionInfo.clear}
                                           onChange={handleInputChange}/>
                                    {conditionInfo.clearingFirm === "ALPA" ? (
                                        <div>
                                            <p className="agreement_check_text text-base uppercase font-bold">
                                                {t('conditions.alpa1')}
                                                <a href="https://files.alpaca.markets/disclosures/library/AcctAppMarginAndCustAgmt.pdf"
                                                   target="_blank" rel="noopener"> {t('conditions.alpa_heading')}</a>
                                                {t('conditions.alpa2')}
                                                <a href="https://files.alpaca.markets/disclosures/library/AcctAppMarginAndCustAgmt.pdf"
                                                   target="_blank" rel="noopener"> {t('conditions.alpa_heading')} </a>
                                                {t('conditions.alpa3')}
                                            </p>
                                            <p className="agreement_check_text text-base uppercase font-bold">
                                                {t('conditions.alpa4')}
                                            </p>
                                        </div>
                                    ) : (
                                        <p className="agreement_check_text text-base uppercase font-bold">
                                            {t('conditions.client_auth_condition')}
                                        </p>
                                    )}
                                </div>
                                {conditionErrors.clear &&
                                    <p className="conditions_info_error text-red-500 text-sm">{conditionErrors.clear}</p>}
                            </Accordion.Body>
                        </Accordion.Item>

                        {campaignSlug === "BLYQ" &&
                            <Accordion.Item eventKey="8">
                                <Accordion.Header>
                                    <Link to="/conditions"
                                          style={{color: "unset"}}>{t('conditions.trading_header')}</Link>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <div className="flex gap-3">
                                        <input type="checkbox" className="agreement_check"
                                               name="trading"
                                               checked={conditionInfo.trading}
                                               onChange={handleInputChange}/>
                                        <p className="agreement_check_text text-base uppercase font-bold">
                                            {t('conditions.trading_text1')} <a className="text-black-alpha-50"
                                                                               target="_blank"
                                                                               rel="noreferrer"
                                                                               href="https://choicetrade-media.s3.amazonaws.com/forms/LimitedTradingAuthorizationFilledByGAT.pdf">
                                            {t('conditions.trading_text2')}</a> {t('conditions.trading_text3')}
                                        </p>
                                    </div>
                                    {conditionErrors.trading &&
                                        <p className="conditions_info_error text-red-500 text-sm">{conditionErrors.trading}</p>}
                                </Accordion.Body>
                            </Accordion.Item>
                        }

                        <Accordion.Item eventKey="5">
                            <Accordion.Header>
                                <Link to="/conditions"
                                      style={{color: "unset"}}>{t('experience.document_delivery')}</Link>
                            </Accordion.Header>
                            <Accordion.Body>
                                <p className="exp_doc_delivery_text text-center font-bold">
                                    {t('experience.additional_fees')}
                                </p>
                                <div className="exp_doc flex flex-wrap gap-8 pt-5 row-gap-3">
                                    <div>
                                        <div className="flex gap-3 flex gap-3">
                                            <input
                                                type="checkbox"
                                                className="delivery_checkbox"
                                                name="agreeConfirm"
                                                checked={conditionInfo.agreeConfirm}
                                                onChange={(e) => handleInputChange(e)}
                                            />
                                            <p className="agreement_check_text text-base uppercase font-bold">{t('experience.trade_conf_email')}</p>
                                        </div>
                                        {conditionErrors.agreeConfirm &&
                                            <p className="conditions_info_error text-red-500 text-sm">{conditionErrors.agreeConfirm}</p>}
                                    </div>
                                    <div>
                                        <div className="flex gap-3">
                                            <input
                                                type="checkbox"
                                                className="delivery_checkbox"
                                                name="agreeEstatement"
                                                checked={conditionInfo.agreeEstatement}
                                                onChange={(e) => handleInputChange(e)}
                                            />
                                            <p className="agreement_check_text text-base uppercase font-bold">{t('experience.account_statement_email')}</p>
                                        </div>
                                        {conditionErrors.agreeEstatement &&
                                            <p className="conditions_info_error text-red-500 text-sm">{conditionErrors.agreeEstatement}</p>}
                                    </div>
                                    <div>
                                        <div className="flex gap-3">
                                            <input
                                                type="checkbox"
                                                className="delivery_checkbox"
                                                name="agreeProxy"
                                                checked={conditionInfo.agreeProxy}
                                                onChange={(e) => handleInputChange(e)}
                                            />
                                            <p className="agreement_check_text text-base uppercase font-bold">{t('experience.proxy_statement_email')}</p>
                                        </div>
                                        {conditionErrors.agreeProxy &&
                                            <p className="conditions_info_error text-red-500 text-sm">{conditionErrors.agreeProxy}</p>}
                                    </div>

                                    <div>
                                        <div className="flex gap-3">
                                            <input
                                                type="checkbox"
                                                className="delivery_checkbox"
                                                name="agreePros"
                                                checked={conditionInfo.agreePros}
                                                onChange={(e) => handleInputChange(e)}
                                            />
                                            <p className="agreement_check_text text-base uppercase font-bold">{t('experience.prospectuses_email')}</p>
                                        </div>
                                        {conditionErrors.agreePros &&
                                            <p className="conditions_info_error text-red-500 text-sm">{conditionErrors.agreePros}</p>}
                                    </div>
                                    <div>
                                        <div className="flex gap-3">
                                            <input
                                                type="checkbox"
                                                className="delivery_checkbox"
                                                name="agreeEtax"
                                                checked={conditionInfo.agreeEtax}
                                                onChange={(e) => handleInputChange(e)}
                                            />
                                            <p className="agreement_check_text text-base uppercase font-bold">{t('experience.tax_document_email')}</p>
                                        </div>
                                        {conditionErrors.agreeEtax &&
                                            <p className="conditions_info_error text-red-500 text-sm">{conditionErrors.agreeEtax}</p>}
                                    </div>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="6">
                            <Accordion.Header>
                                <Link to="/conditions" style={{color: "unset"}}>{t('conditions.privacy')}</Link>
                            </Accordion.Header>
                            <Accordion.Body>
                                <div className="flex gap-3">
                                    <input
                                        type="checkbox"
                                        className="owner_disclosure_check"
                                        name="disclosure"
                                        checked={conditionInfo.disclosure}
                                        onChange={(e) => handleInputChange(e)}
                                    />
                                    <p className="agreement_check_text text-base uppercase font-bold">{t('affiliation.ownership_disclosed')}</p>
                                </div>
                                <div className="flex gap-3">
                                    <input
                                        type="checkbox"
                                        className="owner_disclosure_check"
                                        name="privacy"
                                        checked={conditionInfo.privacy}
                                        onChange={(e) => handleInputChange(e)}
                                    />
                                    <p className="owner_disclosure_text text-lg m-0 font-normal uppercase">{t('affiliation.privacy_and_policy')}
                                        <a target="_blank"
                                           style={{
                                               color: "#817676"
                                           }}
                                           className="no-underline"
                                           href="https://choicetrade.com/legal.php?page=privacy"
                                           rel="noreferrer">{t('affiliation.privacy_policy')}
                                        </a>
                                    </p>
                                </div>
                                {conditionErrors.privacy &&
                                    <p className="text-red-500 mb-0 text-xs m-2">{conditionErrors.privacy}</p>}
                            </Accordion.Body>
                        </Accordion.Item>

                        {foreignFinderData && (
                            <Accordion.Item eventKey="7">
                                <Accordion.Header>
                                    <Link to="/conditions"
                                          style={{color: "unset"}}>{t('conditions.finder_heading')}</Link>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <div>
                                        <p className="finder_info">{t('conditions.finder_text1')}</p>
                                        <p className="finder_info">{t('conditions.finder_text2')}</p>
                                        <p className="finder_info">{t('conditions.finder_text3')}</p>
                                        <p className="finder_info">
                                            {t('conditions.finder_text4')} {foreignFinderData?.hear_about} {t('conditions.finder_text5')}
                                        </p>
                                        <p className="finder_info">
                                            {foreignFinderData?.foreignfinder.map((item, index) =>
                                                item.type === 'text' ? (
                                                    <span key={index}>{item.content} </span>
                                                ) : (
                                                    <a
                                                        key={index}
                                                        href={item.href}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        className="no-underline"
                                                        style={{color: 'unset'}}
                                                    >
                                                        {item.content}
                                                    </a>
                                                )
                                            )}
                                        </p>
                                        <div className="flex gap-3">
                                            <input
                                                type="checkbox"
                                                className="owner_disclosure_check"
                                                name="finder"
                                                checked={conditionInfo.finder}
                                                onChange={(e) => handleInputChange(e)}
                                            />
                                            <p className="agreement_check_text text-base uppercase font-bold">{t('conditions.finder_text6')}</p>
                                        </div>
                                        {conditionErrors.finder &&
                                            <p className="text-red-500 mb-0 text-xs m-2">{conditionErrors.finder}</p>}
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        )}

                        {limitTrade && limitTrade.isLTA === "Y" && (
                            <Accordion.Item eventKey="9">
                                <Accordion.Header>
                                    <Link style={{color: "unset"}}
                                          to="#">
                                        Additional Disclosures
                                    </Link>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p className="flex gap-1">
                                        You grant the
                                        <a href="https://choicetrade-media.s3.amazonaws.com/forms/LimitedTradingAuthorization.pdf"
                                           target="_blank"
                                           rel="noreferrer" style={{color: "unset"}}>
                                            Limited Trading Authorization
                                        </a>
                                        in your account.
                                    </p>
                                    <div>
                                        <div>
                                            {limitTrade && limitTrade.name && (
                                                <p>{limitTrade.name}</p>
                                            )}

                                            {limitTrade && limitTrade.phone && (
                                                <p>{limitTrade.phone}</p>
                                            )}

                                            {limitTrade && limitTrade.address && (
                                                <p>{limitTrade.address}</p>
                                            )}

                                            {limitTrade &&
                                                limitTrade.city &&
                                                limitTrade.state &&
                                                limitTrade.country &&
                                                limitTrade.zip && (
                                                    <p>{limitTrade.city}, {limitTrade.state}, {limitTrade.country}, {limitTrade.zip}</p>
                                                )}
                                        </div>
                                        {limitTrade && limitTrade.note && (
                                            <div dangerouslySetInnerHTML={{__html: limitTrade.note}}
                                                 className="text-center"/>
                                        )}
                                        <div className="flex gap-3">
                                            <input
                                                type="checkbox"
                                                className="owner_disclosure_check"
                                                name="limit"
                                                checked={conditionInfo.limit}
                                                onChange={(e) => handleInputChange(e)}
                                            />
                                            <p className="agreement_check_text text-base uppercase font-bold">
                                                By signing this application, I/we understand, acknowledge and agree with
                                                the
                                                foregoing effective the date of the application.
                                            </p>
                                        </div>
                                        {conditionErrors.limit &&
                                            <p className="text-red-500 mb-0 text-xs m-2">{conditionErrors.limit}</p>}
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        )}
                    </Accordion>
                    <div
                        className="flex sm:justify-content-between justify-content-center align-items-center gap-2 sm:flex-row flex-column row-gap-3 pt-6">
                        <Link className="no-underline" to={backTo}>
                            <button className="back_btn">{t('back_btn')}</button>
                        </Link>
                        <button className="continue_btn" type="submit">{t('next_btn')}</button>
                    </div>

                    <div>
                        {conditionErrors.submitError && (
                            <div className="text-red-500 text-center">
                                {conditionErrors.submitError}
                            </div>
                        )}
                    </div>
                </form>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    conditionInfo: state.conditionInfo,
    appData: state.appData,
    personalData: state.personalData,
    account: state.account
});

const mapDispatchToProps = {
    setConditionInfo,
    setPersonalData,
    setFinder
};

export default connect(mapStateToProps, mapDispatchToProps)(Conditions);